import { render, staticRenderFns } from "./ChatbotDeleted.vue?vue&type=template&id=61ee6b52&scoped=true"
import script from "./ChatbotDeleted.vue?vue&type=script&lang=js"
export * from "./ChatbotDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ee6b52",
  null
  
)

export default component.exports